/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReadAllApiV1NotificationsFeedUserEventReadAllPatchMutationResponse,
  ReadAllApiV1NotificationsFeedUserEventReadAllPatchHeaderParams,
  ReadAllApiV1NotificationsFeedUserEventReadAllPatch422,
} from '../../types/ReadAllApiV1NotificationsFeedUserEventReadAllPatch.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const readAllApiV1NotificationsFeedUserEventReadAllPatchMutationKey = () => [{ url: '/api/v1/notifications_feed_user_event/read_all' }] as const

export type ReadAllApiV1NotificationsFeedUserEventReadAllPatchMutationKey = ReturnType<typeof readAllApiV1NotificationsFeedUserEventReadAllPatchMutationKey>

/**
 * @summary Read All
 * {@link /api/v1/notifications_feed_user_event/read_all}
 */
export async function readAllApiV1NotificationsFeedUserEventReadAllPatch(
  headers?: ReadAllApiV1NotificationsFeedUserEventReadAllPatchHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ReadAllApiV1NotificationsFeedUserEventReadAllPatchMutationResponse,
    ResponseErrorConfig<ReadAllApiV1NotificationsFeedUserEventReadAllPatch422>,
    unknown
  >({ method: 'PATCH', url: `/api/v1/notifications_feed_user_event/read_all`, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

/**
 * @summary Read All
 * {@link /api/v1/notifications_feed_user_event/read_all}
 */
export function useReadAllApiV1NotificationsFeedUserEventReadAllPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReadAllApiV1NotificationsFeedUserEventReadAllPatchMutationResponse,
      ResponseErrorConfig<ReadAllApiV1NotificationsFeedUserEventReadAllPatch422>,
      { headers?: ReadAllApiV1NotificationsFeedUserEventReadAllPatchHeaderParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? readAllApiV1NotificationsFeedUserEventReadAllPatchMutationKey()

  return useMutation<
    ReadAllApiV1NotificationsFeedUserEventReadAllPatchMutationResponse,
    ResponseErrorConfig<ReadAllApiV1NotificationsFeedUserEventReadAllPatch422>,
    { headers?: ReadAllApiV1NotificationsFeedUserEventReadAllPatchHeaderParams },
    TContext
  >(
    {
      mutationFn: async ({ headers }) => {
        return readAllApiV1NotificationsFeedUserEventReadAllPatch(headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}